<template>
  <div class="flex col-center">
    <div :class="['dot',badge_type]"></div>
    <div class="m-l-5">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    badge_type: {
      type: String,
      default: 'primary'
    },
  }
}
</script>

<style lang="less" scoped>
.dot {
  height: 6px;
  width: 6px;
  padding: 0;
  border-radius: 50%;
}

.primary {
  background-color: #409EFF;
}

.info {
  background-color: #909399;
}

.success {
  background-color: #67C23A;
}

.danger {
  background-color: #f56c6c;
}
</style>